import { MenuFloatingButtonsBagButton } from './components';

export const MenuFloatingButtons = {
  Bag: MenuFloatingButtonsBagButton,
};
